export default __webpack_public_path__ + "static/media/course1.202801f7.jpg";